export const SHOPIFY_APP_CLIENT_ID = process.env.REACT_APP_SHOPIFY_APP_CLIENT_ID

export const APP_BRIDGE_CONFIG = {
  apiKey: SHOPIFY_APP_CLIENT_ID,
  host: new URLSearchParams(window.location.search).get('host'),
  forceRedirect: false,
}
